import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetRepaymentScheduleByFundraisingId = (
  fundraisingId,
  groupId,
) => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    queryKey: [
      QUERY_KEYS.loan.repayment_schedule_by_fundraising_id,
      fundraisingId,
      groupId,
    ],
    queryFn: () =>
      loanService
        .repaymentScheduleByFundraisingId(fundraisingId, { group: groupId })
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            return data;
          }
          throw new Error('Fetch failed');
        }),
  });
};
